/**
 * Configuration management for the Solana Staking SDK.
 *
 * @remarks
 * This module provides configuration management functionality following
 * the same patterns as the BD-SDK for consistency.
 */
/**
 * SDK Configuration class for managing settings and options.
 *
 * @example
 * ```typescript
 * const config = new SDKConfiguration({
 *   logLevel: "INFO",
 *   timeout: 30000
 * });
 * ```
 */
export class SDKConfiguration {
    config;
    /**
     * Creates a new SDK configuration instance.
     *
     * @param params - Configuration parameters
     */
    constructor(params = {}) {
        this.config = {
            logLevel: params.logLevel || "INFO",
            timeout: params.timeout || 30000,
            ...params,
        };
    }
    /**
     * Gets the logging level.
     */
    get logLevel() {
        return this.config.logLevel;
    }
    /**
     * Gets the request timeout.
     */
    get timeout() {
        return this.config.timeout;
    }
    /**
     * Gets a configuration value by key.
     *
     * @param key - Configuration key
     * @returns Configuration value
     */
    get(key) {
        return this.config[key];
    }
    /**
     * Gets all configuration parameters.
     */
    getAll() {
        return { ...this.config };
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29uZmlndXJhdGlvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9tYWluL3NoYXJlZC9jb25maWd1cmF0aW9uLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7R0FNRztBQWNIOzs7Ozs7Ozs7O0dBVUc7QUFDSCxNQUFNLE9BQU8sZ0JBQWdCO0lBQ1YsTUFBTSxDQUFxQztJQUU1RDs7OztPQUlHO0lBQ0gsWUFBWSxTQUFtQyxFQUFFO1FBQy9DLElBQUksQ0FBQyxNQUFNLEdBQUc7WUFDWixRQUFRLEVBQUUsTUFBTSxDQUFDLFFBQVEsSUFBSSxNQUFNO1lBQ25DLE9BQU8sRUFBRSxNQUFNLENBQUMsT0FBTyxJQUFJLEtBQUs7WUFDaEMsR0FBRyxNQUFNO1NBQ1YsQ0FBQztJQUNKLENBQUM7SUFFRDs7T0FFRztJQUNILElBQVcsUUFBUTtRQUNqQixPQUFPLElBQUksQ0FBQyxNQUFNLENBQUMsUUFBUSxDQUFDO0lBQzlCLENBQUM7SUFFRDs7T0FFRztJQUNILElBQVcsT0FBTztRQUNoQixPQUFPLElBQUksQ0FBQyxNQUFNLENBQUMsT0FBTyxDQUFDO0lBQzdCLENBQUM7SUFFRDs7Ozs7T0FLRztJQUNJLEdBQUcsQ0FBQyxHQUFXO1FBQ3BCLE9BQU8sSUFBSSxDQUFDLE1BQU0sQ0FBQyxHQUFHLENBQUMsQ0FBQztJQUMxQixDQUFDO0lBRUQ7O09BRUc7SUFDSSxNQUFNO1FBQ1gsT0FBTyxFQUFFLEdBQUcsSUFBSSxDQUFDLE1BQU0sRUFBRSxDQUFDO0lBQzVCLENBQUM7Q0FDRiJ9